import service from "./service";

const storeList = async (search, page, limit) => {
  return service
    .get(`/admin/stores?search=${search}&page=${page}&limit=${limit}`)
    .then((response) => {
      return response;
    });
};

const allStoresList = async () => {
  return service.get(`admin/all-stores-list`);
};

const storeListDelete = async (id) => {
  return service.deleteApi(`admin/stores/${id}`).then((response) => {
    return response;
  });
};

const storeAdd = async (payload) => {
  return service.post(`admin/stores`, payload).then((response) => {
    return response;
  });
};

const getStoreById = async (id) => {
  return service.get(`admin/stores/${id}`).then((response) => {
    return response;
  });
};

const editStore = async (id, payload) => {
  return service.patchApi(`admin/stores/${id}`, payload).then((response) => {
    return response;
  });
};

const approvedStore = async (id, payload) => {
  return service.patchApi(`admin/stores/${id}/approval`, payload).then((response) => {
    return response;
  });
};

export default {
  storeList,
  allStoresList,
  storeListDelete,
  storeAdd,
  getStoreById,
  editStore,
  approvedStore
};
